import { render, staticRenderFns } from "./CreateUserConfirm.vue?vue&type=template&id=63666a9e&scoped=true&"
import script from "./CreateUserConfirm.vue?vue&type=script&lang=js&"
export * from "./CreateUserConfirm.vue?vue&type=script&lang=js&"
import style0 from "./CreateUserConfirm.vue?vue&type=style&index=0&id=63666a9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63666a9e",
  null
  
)

export default component.exports